<template>
 <div class="container">

        <h2>一、立返优惠券发放规则</h2>
        <p>每次开通对应会员档位，均可立返 1 张对应的无门槛优惠券（<span class="highlight">50 元 / 150 元 / 600 元</span>），立返券有效期 7 天，有效期自购买当日起计算。</p>

        <h2>二、6 元月卡券发放规则</h2>
        <p>开通月卡后，立即发放 1 张 6 元月卡券；会员有效期内，每日 <span class="highlight">0:10</span> 系统将自动发放 1 张 6 元月卡券，无需手动领取。</p>

        <h2>三、会员有效期规则</h2>
        <p>会员有效期自开通当日起算，其中：</p>
        <ul>
            <li>月卡：30 天</li>
            <li>季卡：90 天</li>
            <li>年卡：360 天</li>
        </ul>
        <p>多次开通会员仅叠加有效期，会员最高有效天数不超过 <span class="highlight">720 天</span>。</p>

        <h2>四、优惠券有效期规则</h2>
        <ul>
            <li>开通立返的各类优惠券，有效期统一为 <span class="highlight">7 天</span>；</li>
            <li>每日自动发放的 6 元月卡券，有效期为 <span class="highlight">7 天</span>；</li>
            <li>所有优惠券过期后均无法补领，请在有效期内及时使用。</li>
        </ul>

        <h2>五、优惠券适用游戏范围</h2>
        <ul>
            <li>月卡发放的优惠券可在平台绝大多数游戏中使用，具体支持使用的游戏名单，可在月卡会员页面的可用游戏清单中查看。</li>
        </ul>

        <h2>六、折扣游戏使用规则</h2>
        <p>月卡相关优惠券在不同折扣游戏内可享受膨胀权益，具体如下：</p>
        <table class="rule-table">
            <tr>
                <th>游戏折扣</th>
                <th>优惠券膨胀倍数</th>
            </tr>
            <tr>
                <td>1 折游戏</td>
                <td>10 倍</td>
            </tr>
            <tr>
                <td>0.1 折游戏</td>
                <td>100 倍</td>
            </tr>
            <tr>
                <td>0.05 折游戏</td>
                <td>200 倍</td>
            </tr>
        </table>
        <p>优惠券在游戏内展示金额为膨胀后金额，实际抵扣以游戏内显示为准。</p>

        <h2>七、特别提醒</h2>
        <div class="tip-box">
            <p>1. 月卡会员属于虚拟商品，不支持退货，开通前请确认所游玩游戏是否支持优惠券使用。</p>
            <p>2. 未成年用户无法开通及使用本会员相关功能。</p>
            <p>3. 若对会员规则、优惠券使用等有任何疑问，可及时联系客服咨询。</p>
            <p>4. 本规则最终解释权归平台所有。</p>
        </div>
    </div>
</template>
<script>
import { useRouter } from "vue-router";
import { reactive, onMounted } from "vue";
import { useStore } from "vuex";
import { monthCardCouponRecord } from "@/api/yzuser.js";
import { setToken, getToken, getUid } from "@/utils/auth";
import { getQueryString } from "@/utils/location";
import { Toast } from "vant";
export default {
  name: "monthCardDesc",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      getLists: [],
    });
    onMounted(() => {});
    return {
      state,
    };
  },
};
</script>
<style scoped="scoped">
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
        }

        body {
            background-color: #ffffff;
            color: #333;
            line-height: 1.8;
            font-size: 15px;
            padding: 15px;
        }

        .container {
          padding: 0 32px;
        }


        h1 {
            font-size: 20px;
            text-align: center;
            margin-bottom: 25px;
            font-weight: 600;
            color: #222;
            padding-bottom: 15px;
            border-bottom: 1px solid #eee;
            height: 100px;
            line-height: 100px;
        }

        h2 {
            font-size: 17px;
            margin: 28px 0 12px;
            font-weight: 600;
            color: #222;
            display: flex;
            align-items: center;
        }

        h2::before {
            content: "";
            display: inline-block;
            width: 4px;
            height: 18px;
            background-color: #00D9C5;
            margin-right: 10px;
            border-radius: 2px;
        }

        p {
            margin: 8px 0;
            text-align: justify;
        }

        ul {
            margin: 10px 0 10px 20px;
        }

        li {
            margin: 6px 0;
        }

        .highlight {
            color: #000000;
            font-weight: 600;
        }

        .rule-table {
            width: 100%;
            border-collapse: collapse;
            margin: 15px 0;
            font-size: 14px;
        }

        .rule-table th,
        .rule-table td {
            border: 1px solid #e5e5e5;
            padding: 10px 8px;
            text-align: left;
        }

        .rule-table th {
            background-color: #f8f9fa;
            font-weight: 600;
        }

        .tip-box {
            background-color: #f8ffff;
            border: 1px solid #d6ffee;
            border-radius: 8px;
            padding: 12px;
            margin: 15px 0;
            font-size: 14px;
        }

        .remind {
            margin-top: 20px;
            padding-top: 15px;
            border-top: 1px dashed #eee;
        }
      @media screen and (max-width: 800px) {
            body {
                font-size: 14px;
            }

            h1 {
                font-size: 18px;
            }

            h2 {
                font-size: 16px;
            }

            .rule-table {
                font-size: 13px;
            }

          .tip-box {
              font-size: 14px;
          }
        }

</style>
